import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import MovieCard from '@/components/feature/MovieCard';
import { categories, getMoviesByCategory } from '@/mocks/movies';

export default function CategoryPage() {
  const { type } = useParams<{ type: string }>();
  const currentCategory = categories.find((c) => c.key === type);
  const movieList = type ? getMoviesByCategory(type) : [];
  const categoryLabel = currentCategory?.label || '电影';

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryLabel} - 8090影视`,
    description: `8090影视${categoryLabel}分类，聚合高清${categoryLabel}资源，涵盖最新${categoryLabel}和经典${categoryLabel}，在线流畅观看`,
    url: `https://8090movie.com/category/${type}`,
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: movieList.map((movie, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Movie',
          name: movie.title,
          url: `https://8090movie.com/movie/${movie.id}`,
        },
      })),
    },
  };

  return (
    <>
      <SEOHead
        title={`${categoryLabel} - 8090影视电影大全 | 高清${categoryLabel}在线观看`}
        description={`8090影视${categoryLabel}频道，聚合最新${categoryLabel}、经典${categoryLabel}等高清电影资源，涵盖海量片库，流畅播放尽在掌握。`}
        keywords={`8090影视,${categoryLabel},电影大全,最新${categoryLabel},经典${categoryLabel},高清${categoryLabel},电影在线观看`}
        canonicalUrl={`https://8090movie.com/category/${type}`}
        schema={pageSchema}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-20 pb-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: categoryLabel },
            ]}
          />

          <div className="mb-8">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-white">
              {categoryLabel}
            </h1>
            <p className="text-cinema-text-dim text-sm mt-2">
              共找到 <strong className="text-cinema-gold">{movieList.length}</strong> 部{categoryLabel}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  cat.key === type
                    ? 'bg-cinema-gold text-cinema-black font-medium'
                    : 'bg-cinema-card text-cinema-text-dim hover:text-white hover:bg-cinema-border'
                }`}
              >
                {cat.label}
              </Link>
            ))}
          </div>

          {movieList.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
              {movieList.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-cinema-card mb-4">
                <i className="ri-film-line text-3xl text-cinema-text-dim"></i>
              </div>
              <p className="text-cinema-text-dim text-lg">暂无{categoryLabel}资源</p>
              <Link
                to="/"
                className="inline-block mt-4 text-cinema-gold text-sm hover:text-cinema-gold-light transition-colors cursor-pointer"
              >
                返回首页
              </Link>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}